<template>
    <div class="transactionRecords">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="buyerName" label="买家" width="180">
                <template slot-scope="scope">
                    {{scope.row.buyerName | phoneFilter}}
                </template>
            </el-table-column>
            <el-table-column prop="otherName" label="名称" width="120" >
                <template slot-scope="scope">
                    <div style="cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" @click="openDetails(scope.row)">{{ scope.row.otherName }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="成交积分" align="center" width="120" v-if="orderType == 'INTEGRAL'">
                <template slot-scope="scope">
                    <span class="red">
                        {{scope.row.totalPrice | getArea}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="成交金额" align="center"  v-else>
                <template slot-scope="scope">
                    <span class="red">
                        ¥{{scope.row.totalPrice | getArea}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="orderTypeCn" label="订单类型"> </el-table-column>
            <el-table-column align="center" prop="totalNum" label="购买数量" width="80"> </el-table-column>
            <el-table-column prop="orderCreatedDate" label="购买时间" width="200"> </el-table-column>
        </el-table>
        <el-pagination
                v-if="tableData.length>0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="current"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import { orderRecordList } from '../../utils/interface';
    export default {
        name:"transactionRecords",
        data(){
            return {
                tableData: [],
                current:1,
                pageSize:10,
                total:0,
                goodsUuid:"",
                enterPriseUuid:"",
                detailUuid:"",
                orderType:"",
                activityUuid:"",
            }
        },
        filters:{
            phoneFilter(val) {
                // if(val.split('').length>4){
                //     return val.substring(0,2) + " **** " + val.substring(val.split('').length-2,val.split('').length);
                // }else{
                //     return val;
                // }
                if(val.length > 0){
                    return  val.substring(0,1) + "**";
                }
                //let reg=/^(.{2}).*(.{2})$/;
                //return val.replace(reg,'$1****$2');
            },
            getArea(val) {
                var p = val.toString();
                if(p.length > 0){
                    return  "****" + p.substring(p.length-1,p.length);
                }
                /*if(val.length>6){
                    return val.replace(/\B(?=(\d{3})+(?!\d))/g,',');
                }else{
                    return val;
                }*/
            }
        },
        methods: {
            init(goodsUuid,orderType,enterPriseUuid,detailUuid,activityUuid) {
                this.enterPriseUuid = enterPriseUuid;
                this.orderType = orderType;
                this.goodsUuid = goodsUuid;
                this.detailUuid = detailUuid;
                this.activityUuid = activityUuid;
                this.getList();
            },
            getList(){
                let params = {
                    orderType:this.orderType,
                    enterPriseUuid:this.enterPriseUuid,
                    goodsUuid:this.goodsUuid,
                    detailUuid:this.detailUuid,
                    activityUuid:this.activityUuid,
                    current:this.current,
                    pageSize:this.pageSize,
                };
                orderRecordList(params).then((res)=>{
                    this.tableData = [];
                    this.current = res.current;
                    this.total = res.total;
                    this.tableData = res.list;
                });
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
                window.scrollTo(0,0);
                this.getList();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            // 跳转详情页
            openDetails(item){
                console.log(item);
                if(item.orderType==="SHOP"){
                    let routeData = this.$router.resolve({
                        name: "shopGoodDetails",
                        params: {uuid: item.goodsUuid},
                    });
                    window.open(routeData.href, "_blank");
                }else if(item.orderType==="SERVICE"){
                    let routeData = this.$router.resolve({
                        name: "printServiceDetails",
                        params: {uuid: item.detailUuid},
                    });
                    window.open(routeData.href, "_blank");
                }else if (item.orderType==="MODEL"){
                  let routeData = this.$router.resolve({
                    name: "modelDetails",
                    query: {uuid: item.detailUuid},
                  });
                  window.open(routeData.href, "_blank");
                }
                /*else if(item.orderType==="INTEGRAL"){
                    let routeData = this.$router.resolve({
                        name: "activeShopGoodDetails",
                        query: { activeUuid:this.uuid,goodUuid: item.goodsUuid,activityType:this.form.activityType },
                    });
                    window.open(routeData.href, "_blank");
                }*/
            },
        },
    };
</script>

<style lang="less" scoped>
    .red {
        color: rgb(226, 12, 12);
    }
</style>



// WEBPACK FOOTER //
// src/components/transactionRecords/transactionRecords.vue